import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, AfterViewChecked, OnDestroy, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { AuthenticationService } from 'app/services';
import { fuseAnimations } from '@fuse/animations';
import { UntypedFormControl } from '@angular/forms';
import { merge, Subject } from 'rxjs';
import { startWith, tap, takeUntil, switchMap } from 'rxjs/operators';
import { forEach, isString, unionBy, ceil } from 'lodash';
import { BaseService } from 'app/_helpers/base/base.service';
import { FiltersComponent } from '../../filters/filters.component';
import { MatDialog } from '@angular/material/dialog';
import { QuickEditComponent } from 'app/main/master-data/accounts/quick-edit/quick-edit.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-wg-new-accounts',
  templateUrl: './wg-new-accounts.component.html',
  styleUrls: ['./wg-new-accounts.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class WgNewAccountsComponent implements OnInit, AfterViewChecked, OnDestroy {

  user: any;
  accountsDataRange: UntypedFormControl = new UntypedFormControl('this_month');
  accountsDataPage: UntypedFormControl = new UntypedFormControl(1);
  accountsData: any = {};
  loadringData: boolean;
  @ViewChild('accountsWidget', { static: false }) private accountsWidget: ElementRef;
  reload: EventEmitter<any> = new EventEmitter();
  accountsFilter = {} as any;
  accountsWidgetChecked: boolean;
  searchDialogRef: any;

  private _unsubscribeAll: Subject<any>;

  constructor(
    private _authenticationService: AuthenticationService,
    private cdRef: ChangeDetectorRef,
    private _matDialog: MatDialog,
    private _gService: BaseService,
    private _snackBar: MatSnackBar,
    private _translateService: TranslateService
  ) {
    this.accountsWidgetChecked = false;
    this.user = this._authenticationService.currentUserValue;
    if (this.user.user_role === 'agency_manager' && !this.user.user_office_data.master_office) {
      this.accountsFilter = { offices: [this.user.user_office_id] };
    } else if (this.user.user_role === 'agent' || this.user.user_role === 'agent_medium' || this.user.user_role === 'admin_agent_light') {
      this.accountsFilter = { users: [this.user._id] };
    }
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {

    merge(this.accountsDataRange.valueChanges, this.accountsDataPage.valueChanges, this.reload)
      .pipe(
        startWith('today'),
        tap(() => this.loadringData = true),
        takeUntil(this._unsubscribeAll),
        switchMap((change: string | number) => {
          if (typeof change === 'string') {
            this.accountsDataPage.setValue(1, { emitEvent: false });
            if (this.accountsWidget) {
              this.accountsWidget.nativeElement.scrollTop = 0;
            }
          }
          return this._gService.post(`dashboard/new_accounts?range=${this.accountsDataRange.value}&page=${this.accountsDataPage.value}`, this.accountsFilter, 'nodejs');
        })
      )
      .subscribe((data: any) => {
        if (data.docs) {
          forEach(data.docs, (doc) => {
            if (isString(doc.assigned_to)) {
              doc.assigned_to = [doc.assigned_to];
            }
          });
        }
        if (!this.accountsData.docs || this.accountsDataPage.value === 1) {
          this.accountsData = data;
        } else {
          this.accountsData.docs = unionBy(this.accountsData.docs, data.docs, 'id');
        }
        this.loadringData = false;
      }, () => this.loadringData = false);

  }

  updateData(data: any, tab: string): void {
    const dialogRef = this._matDialog.open(QuickEditComponent, {
      disableClose: false,
      panelClass: 'event-form-dialog',
      data: {
        tab: tab,
        account: data
      },
    });
    dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.reload.next(true);
          this._snackBar.open(this._translateService.instant('Updated successfully'), this._translateService.instant('Close'), {
            duration: 2000,
          });
        }
      });
  }

  openFilterModal(): void {
    this.searchDialogRef = this._matDialog.open(FiltersComponent, {
      panelClass: 'event-form-dialog',
      data: 'userOffice',
    });
    this.searchDialogRef.afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: any) => {
        if (response) {
          this.accountsFilter = {};
          this.accountsFilter = response;
          this.reload.next(true);
        }
      });
  }

  ngAfterViewChecked(): void {
    if (!this.accountsWidgetChecked && this.accountsWidget) {
      this.accountsWidget.nativeElement
        .addEventListener('scroll', (event: any) => this.widgetScroll(event, this.accountsDataPage, this.accountsData), true);
      this.accountsWidgetChecked = true;
    }
    this.cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.accountsWidget && this.accountsWidget.nativeElement) {
      this.accountsWidget.nativeElement
        .removeEventListener('scroll', (event: any) => this.widgetScroll(event, this.accountsDataPage, this.accountsData), true);
    }
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  widgetScroll(event: any, dataPage: UntypedFormControl, data: any): void {
    if (event.target.scrollTop + event.target.clientHeight <= event.target.scrollHeight && dataPage.value < ceil(data.total / data.limit)) {
      dataPage.setValue(dataPage.value + 1);
    }
  }

}
